import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd-mobile'
import ArrowLeft from '../../../asserts/icons/onboarding/arrow-left.svg'

const Container = styled.footer`
  display: flex;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  left: 0;
  right: 0;
  padding: 1.5em;
  z-index: 2;
  padding-left: 0;
  justify-content: space-between;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
  button {
    font-size: 14px;
    letter-spacing: 2.8px;
    font-weight: 600;
    font-family: 'Gilroy';
    padding: 13px 24px;
  }
  .back-button {
    display: flex;
    span {
      padding-top: 2px;
      padding-left: 10px;
    }
  }
  .next-button {
    display: flex;
    span {
      padding-top: 1px;
      padding-right: 10px;
    }
  }
  @media (min-width: 1024px) {
    left: 27%;
  }
`

export default function StepFooter(props) {
  const {
    showBack,
    back,
    confirmOpr,
    onComplete,
    completeText,
    loading,
    disabledNext = false
  } = props

  return (
    <Container>
      <div>
        {showBack && (
          <Button color="primary" fill="none" onClick={back}>
            <div className="back-button">
              <img src={ArrowLeft} alt="" />
              <span>BACK</span>
            </div>
          </Button>
        )}
      </div>
      <div>
        {confirmOpr ? (
          confirmOpr
        ) : (
          <Button
            block
            disabled={disabledNext}
            loading={loading}
            shape="rounded"
            color="primary"
            onClick={() => onComplete && onComplete()}
          >
            {completeText || 'COMPLETE'}
          </Button>
        )}
      </div>
    </Container>
  )
}
